/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

import React from "react";

import OutputValue from "./OutputValue";
import InputLabel from "../Inputs/Layout/InputLabel";
import InputContainer from "../Inputs/Layout/InputContainer";
import { SHORT_DATE_FORMAT } from "../utils/date-utils";

import { useResources } from "@aetonix/hooks";

export default function OutputText(props) {
	const schema = props.schema;
	const { formatDate } = useResources();

	let data = props.data;
	if (schema.inputType === "date" && data) {
		data = formatDate(data, SHORT_DATE_FORMAT, "date");
	}

	if((schema.inputType === "time" || schema.format === "time") && data)
		data = data.hours + ":" + data.minutes;

	return (
		<InputContainer style={props.style}>
			<InputLabel schema={schema} title={props.title} contrast={props.contrast} />
			<OutputValue schema={schema} data={data} contrast={props.contrast} />
		</InputContainer>
	);
}